import { render, staticRenderFns } from "./CourseDocuments.vue?vue&type=template&id=9869b69c"
import script from "./CourseDocuments.vue?vue&type=script&lang=js"
export * from "./CourseDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports